const selectionsElem = document.querySelectorAll('.selections');

selectionsElem.forEach((elem) => {
  const input = elem.querySelector('.selections__header input');
  input.addEventListener('change', () => {
    const parent = elem.closest('.selections');
    parent.classList.toggle('is-open', input.checked);
  });
});
